import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import Tag from './tag';
import { USER_ACCESS_TOKEN } from '@constants/auth';
import { tokenStorage } from '@utils/tokenStorage';
import { withReauth } from './baseQueryWithReauth';

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_APP_API_URL,
  prepareHeaders: headers => {
    const token = tokenStorage.getToken(USER_ACCESS_TOKEN);
    if (token) headers.set('Authorization', `Bearer ${token}`);

    return headers;
  },
});

export const emptyBaseSplitApi = createApi({
  baseQuery: withReauth(baseQuery),
  tagTypes: Object.values(Tag),
  endpoints: () => ({}),
});

export const invalidateAllTags = () => emptyBaseSplitApi.util.invalidateTags(Object.values(Tag));
